<template>
  <div class="sidebarleft">
    <div class="optlist">
      <SmallOption
        v-for="option in options" 
        @click="optionClicked(option)"
        class="sbopt"
        :active="option.value == selectedOption?.value"
        :image="option.image"
        :imageblack="option.imageblack"
        :key="option.id" 
        :text="option.name" />
    </div>
    <div class="picker">
      <DatePicker
        @date-selected="dateSelected"
        :date="ndate"
        :monthpicker="showMonth"
        :weekpicker="showWeekly" />
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import DatePicker from '@/components/datepicker/datepicker.vue';
import SmallOption from '@/components/smallOption.vue';
import { useEventSearch } from "@/stores/eventSearch.ts";


export default {
  name: 'SideBarFilters',
  props: ["options","selectedOption"],
  emit:["setOption","optionChosen","dateChange"],
  components:{
    DatePicker,
    SmallOption
  },
  setup(){
    const eventsearch = useEventSearch();
    const currentweek = computed(()=> eventsearch.selectedWeek);

    function updateMonthCalendarUI(month) {
      eventsearch.updateMonthCalendarUI(month);
    }
    return {
      updateMonthCalendarUI,
      currentweek
    }
  },
  data() {
    return {
      ndate: null
    }
  },
  mounted(){
    this.updateNDate();
  },
  computed:{
    showWeekly(){
      return this.selectedOption == null || this.selectedOption?.id != 3
    },
    showMonth(){
      return this.selectedOption?.id == 3;
    }
  },
  watch:{
    currentweek(){
      this.updateNDate(); 
    }
  },
  methods: {
    updateNDate(){
      this.ndate = [new Date(this.currentweek.start), new Date(this.currentweek.end)]; 
    },
    optionClicked(option){
      this.$emit('optionChosen',option);
    },
    dateSelected(data,currentmonth){
      let dates = null;
      let month = null;
      if(this.selectedOption?.id == 3){
        dates = {
          "start": new Date(data.year, data.month, 1),
          "end": new Date(data.year, data.month + 1, 0)
        }
        month = data.month;
      }else{
        dates = {
          "start": data[0],
          "end": data[1]
        }
        month = currentmonth;
      }
      this.updateMonthCalendarUI(month);
      this.$emit("dateChange",dates);
    }
  }
}
</script>

<style>
.sbopt img{
  width: 30px;
  margin-right: 7px;
}
.sbopt p {
  font-size: 15px;
  margin-top: 0;
} 

.sbopt.active, .sbopt:hover{
  color:#2650e7;
}

</style>

<style scoped>
.picker{
  margin-bottom: 20px;
  height: 318px;
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}

.sidebarleft{
  position: relative;
  padding-top: 20px;
  z-index: 100;
}
.optlist{
  font-family: "Montserrat Light";
  margin-bottom: 30px;
}
.sbopt{
  margin-bottom: 0;
  padding: 10px 10px;
  display: flex;
}

.sbopt.active{
  color: #2650e7;
}

.sbopt:hover{
  cursor: pointer;
}
</style>